export default __webpack_public_path__ + "static/media/kuchnia6.14bb05e9.jpg";